import { render, staticRenderFns } from "./PackageEditorModal.vue?vue&type=template&id=d453ea00&"
import script from "./PackageEditorModal.vue?vue&type=script&lang=js&"
export * from "./PackageEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./PackageEditorModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports